// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidItemCostHistoryQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.BidContractLineItemFilter>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type BidItemCostHistoryQuery = { __typename?: 'Query', bidContractLineItemsPage: { __typename?: 'BidContractLineItemsPageResult', entities: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, revision: { __typename?: 'BidContractRevision', id: string, startDate: Types.Scalars['Date']['input'], status: { __typename?: 'BidContractRevisionStatusDetail', name: string, code: Types.BidContractRevisionStatus }, bidContract: { __typename?: 'BidContract', id: string, displayName: string, developments: Array<{ __typename?: 'Development', id: string, name: string }>, projects: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > } } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type BidItemCostHistory_BidContractLineItemsFragment = { __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, revision: { __typename?: 'BidContractRevision', id: string, startDate: Types.Scalars['Date']['input'], status: { __typename?: 'BidContractRevisionStatusDetail', name: string, code: Types.BidContractRevisionStatus }, bidContract: { __typename?: 'BidContract', id: string, displayName: string, developments: Array<{ __typename?: 'Development', id: string, name: string }>, projects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > } } };

export const BidItemCostHistory_BidContractLineItemsFragmentDoc = gql`
    fragment BidItemCostHistory_BidContractLineItems on BidContractLineItem {
  id
  totalCostInCents
  revision {
    id
    startDate
    status {
      name
      code
    }
    bidContract {
      id
      displayName
      developments {
        ...Named
      }
      projects {
        ...Named
      }
    }
  }
}
    ${NamedFragmentDoc}`;
export const BidItemCostHistoryDocument = gql`
    query BidItemCostHistory($filter: BidContractLineItemFilter, $page: PageFilter) {
  bidContractLineItemsPage(filter: $filter, page: $page) {
    entities {
      ...BidItemCostHistory_BidContractLineItems
    }
    pageInfo {
      totalCount
    }
  }
}
    ${BidItemCostHistory_BidContractLineItemsFragmentDoc}`;

/**
 * __useBidItemCostHistoryQuery__
 *
 * To run a query within a React component, call `useBidItemCostHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidItemCostHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidItemCostHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useBidItemCostHistoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BidItemCostHistoryQuery, BidItemCostHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidItemCostHistoryQuery, BidItemCostHistoryQueryVariables>(BidItemCostHistoryDocument, options);
      }
export function useBidItemCostHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidItemCostHistoryQuery, BidItemCostHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidItemCostHistoryQuery, BidItemCostHistoryQueryVariables>(BidItemCostHistoryDocument, options);
        }
// @ts-ignore
export function useBidItemCostHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidItemCostHistoryQuery, BidItemCostHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidItemCostHistoryQuery, BidItemCostHistoryQueryVariables>;
export function useBidItemCostHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidItemCostHistoryQuery, BidItemCostHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidItemCostHistoryQuery | undefined, BidItemCostHistoryQueryVariables>;
export function useBidItemCostHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidItemCostHistoryQuery, BidItemCostHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidItemCostHistoryQuery, BidItemCostHistoryQueryVariables>(BidItemCostHistoryDocument, options);
        }
export type BidItemCostHistoryQueryHookResult = ReturnType<typeof useBidItemCostHistoryQuery>;
export type BidItemCostHistoryLazyQueryHookResult = ReturnType<typeof useBidItemCostHistoryLazyQuery>;
export type BidItemCostHistorySuspenseQueryHookResult = ReturnType<typeof useBidItemCostHistorySuspenseQuery>;
export type BidItemCostHistoryQueryResult = ApolloReactCommon.QueryResult<BidItemCostHistoryQuery, BidItemCostHistoryQueryVariables>;